export default "__VITE_ASSET__DYBzSEL___"